<template>
  <div class="invite-box" :style="{ width: itemWidth + 'px', height: itemHeight + 'px', left: left + 'px', top: top + 'px' }" ref="div" @click="onBtnClicked">
    <span>{{ text1 }}</span>
    <br />
    <span>{{ text2 }}</span>
  </div>
</template>

<script>
export default {
  name: 'FloatDiv',
  props: {
    text1: {
      type: String,
      default: '新增',
    },
    text2: {
      type: String,
      default: '代理',
    },
    itemWidth: {
      type: Number,
      default: 60,
    },
    itemHeight: {
      type: Number,
      default: 60,
    },
    gapWidth: {
      type: Number,
      default: 10,
    },
    coefficientHeight: {
      type: Number,
      default: 0.9,
    },
  },
  data() {
    return {
      timer: null,
      currentTop: 0,
      clientWidth: 0,
      clientHeight: 0,
      left: 0,
      top: 0,
    };
  },
  created() {
    this.clientWidth = document.documentElement.clientWidth;
    this.clientHeight = document.documentElement.clientHeight;
    this.left = this.clientWidth - this.itemWidth - this.gapWidth;
    this.top = this.clientHeight * this.coefficientHeight;
  },
  mounted() {
    window.addEventListener('scroll', this.handleScrollStart);
    this.$nextTick(() => {
      const div = this.$refs.div;
      div.addEventListener('touchstart', () => {
        div.style.transition = 'none';
      });
      div.addEventListener('touchmove', e => {
        if (e.targetTouches.length === 1) {
          const touch = event.targetTouches[0];
          this.left = touch.clientX - this.itemWidth / 2;
          this.top = touch.clientY - this.itemHeight / 2;
        }
      });
      div.addEventListener('touchend', () => {
        div.style.transition = 'all 0.3s';
        if (this.left > this.clientWidth / 2) {
          this.left = this.clientWidth - this.itemWidth - this.gapWidth;
        } else {
          this.left = this.gapWidth;
        }
      });
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScrollStart);
  },
  methods: {
    onBtnClicked() {
      this.$emit('click');
    },
    handleScrollStart() {
      this.timer && clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.handleScrollEnd();
      }, 300);
      this.currentTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (this.left > this.clientWidth / 2) {
        this.left = this.clientWidth - this.itemWidth / 2;
      } else {
        this.left = -this.itemWidth / 2;
      }
    },
    handleScrollEnd() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop === this.currentTop) {
        if (this.left > this.clientWidth / 2) {
          this.left = this.clientWidth - this.itemWidth - this.gapWidth;
        } else {
          this.left = this.gapWidth;
        }
        clearTimeout(this.timer);
      }
    },
  },
};
</script>
